export const AUDIENCES_QUERY_KEY = "reach-audiences";
export const CAMPAIGNS_QUERY_KEY = "reach-campaigns";
export const AUDIENCE_RECALCULATION_STATUS_QUERY_KEY = "reach-audience-recalculation-status";
export const SEGMENTS_QUERY_KEY = "reach-segments";
export const PROMOS_QUERY_KEY = "reach-promos";
export const SEGMENT_SCHEMA_QUERY_KEY = "reach-segment-schema";
export const TEMPLATES_QUERY_KEY = "reach-templates";
export const SNIPPETS_QUERY_KEY = "reach-snippets";
export const SBT_TEMPLATES_QUERY_KEY = "reach-sbt-templates";
export const ASSETS_QUERY_KEY = "reach-assets";
export const TEMPLATE_RENDER_QUERY_KEY = "reach-template-render";
export const REACH_USER_QUERY_KEY = "reach-user";
export const ACCOUNTS_SEARCH_QUERY_KEY = "reach-accounts-search";
export const PRODUCTS_SEARCH_QUERY_KEY = "reach-products-search";
export const CURRENT_CREDITORS_SEARCH_QUERY_KEY = "reach-current-creditors-search";
export const DASHBOARD_QUERY_KEY = "dashboard";
export const EMAIL_SPAM_CHECK_QUERY_KEY = "reach-email-spam-check";
export const RESOURCE_USAGES_QUERY_KEY = "reach-resource-usages";
export const PAYMENT_FLOWS_QUERY_KEY = "reach-payment-flows";
export const PAYMENT_FLOW_FEATURE_FLAGS_QUERY_KEY = "reach-payment-flow-feature-flags";
export const PAYMENT_FLOW_SCHEMA_QUERY_KEY = "reach-payment-flow-schema";
export const TRIGGERS_QUERY_KEY = "reach-triggers";
export const TRIGGER_SCHEMA_QUERY_KEY = "reach-trigger-schema";
export const TRIGGER_LAST_PAYLOAD_QUERY_KEY = "reach-trigger-last-payload";
export const TRIGGER_ACCOUNT_PAYLOAD_QUERY_KEY = "reach-trigger-account-payload";
export const TRIGGER_PREVIEW_QUERY_KEY = "reach-trigger-preview";
export const TRIGGER_TEMPLATES_QUERY_KEY = "reach-trigger-templates";

export const TRIGGER_TEMPLATE_CACHE_KEYS = [
  [TEMPLATES_QUERY_KEY, TRIGGER_TEMPLATES_QUERY_KEY],
  [TEMPLATES_QUERY_KEY, TRIGGER_PREVIEW_QUERY_KEY],
];
